// extracted by mini-css-extract-plugin
module.exports = {"row":"_2CI465FsP7z_D--DdvBQwM","col":"_2QAlVNli4O-JqgsCTgTjPn"};